<!-- Ported from the Polaris kit: src/product/components/RuleCard.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// One rule the agent follows, in the owner's words. It can be edited in place (Enter saves, Escape leaves it) or deleted; selectable
// when several are handled at once.
import { useI18n } from 'vue-i18n';
import { ref, watch } from 'vue';
import { Edit16, TrashCan16 } from '@carbon/icons-vue';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Input } from '../ui/input';
import { Item, ItemActions, ItemContent } from '../ui/item';

const props = defineProps({
  content: { type: String, required: true },
  selectable: Boolean,
  selected: Boolean,
});

const emit = defineEmits(['select', 'edit', 'delete']);

const { t } = useI18n();

const editing = ref(false);
const draft = ref(props.content);
const field = ref(null);
watch(
  () => props.content,
  value => {
    draft.value = value;
  }
);
const start = () => {
  editing.value = true;
  draft.value = props.content;
  requestAnimationFrame(() => field.value?.$el?.focus?.());
};
const save = () => {
  const text = draft.value.trim();
  editing.value = false;
  if (text && text !== props.content) emit('edit', text);
  else draft.value = props.content;
};
const leave = () => {
  editing.value = false;
  draft.value = props.content;
};
</script>

<template>
  <Item variant="outline" size="sm" class="min-w-0 flex-nowrap" data-rule-card>
    <label
      v-if="selectable"
      class="flex size-8 shrink-0 items-center justify-center"
      ><Checkbox
        :model-value="selected"
        :aria-label="t('POLARIS.CARDS.SELECT', { item: content })"
        @update:model-value="emit('select')"
    /></label>
    <ItemContent class="min-w-0">
      <Input
        v-if="editing"
        ref="field"
        v-model="draft"
        :aria-label="t('POLARIS.CARDS.RULE')"
        @keydown.enter.prevent="save"
        @keydown.esc.prevent="leave"
        @blur="save"
      />
      <p v-else class="type-polaris-body">{{ content }}</p>
    </ItemContent>
    <ItemActions v-if="!editing">
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        :aria-label="`Edit the rule: ${content}`"
        @click="start"
      >
        <Edit16 aria-hidden="true" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        :aria-label="`Delete the rule: ${content}`"
        @click="emit('delete')"
      >
        <TrashCan16 aria-hidden="true" />
      </Button>
    </ItemActions>
  </Item>
</template>
